import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth-guard.guard';
import { TourModeGuard } from './guards/tour-mode.guard';
import { environment } from 'src/environments/environment';

// Testing flag - set to false for production
const TESTING_TOURS = false;

const routes: Routes = [
  {
    path: '',
    redirectTo: TESTING_TOURS ? 'tours' : 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },  
  {
    path: 'intercom',
    loadChildren: () => import('./pages/intercom/intercom.module').then(m => m.IntercomPageModule),
    canActivate: [AuthGuard, TourModeGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsModule),
    canActivate: [AuthGuard, TourModeGuard]
  },
  // Setup onboarding is enabled in every build configuration now. The conditional spread
  // stays as the single switch: flipping setupOnboardingEnabled off omits the route entirely
  // rather than leaving it reachable by URL.
  ...(environment.setupOnboardingEnabled ? [{
    path: 'setup',
    loadChildren: () => import('./pages/setup/setup.module').then(m => m.SetupPageModule),
    canActivate: [AuthGuard, TourModeGuard]
  }] : []),
  {
    path: 'scenes',
    canActivate: [AuthGuard, TourModeGuard],
    loadChildren: () => import('./shared/dashboard-widgets/scenes-widget/scene-editor/scene-editor-page.module').then(m => m.SceneEditorPageModule),
  },
  {
    path: 'intro',
    loadChildren: () => import('./pages/intro/intro.module').then(m => m.IntroPageModule),
  },
  {
    path: 'tours',
    loadChildren: () => import('./pages/tours/tours.module').then(m => m.ToursModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }